import AjaxLoader from '../ajax-loader/ajax-loader';

const BS_CLASS_NAME_POSITION_ABSOLUTE = 'position-absolute';
const BS_CLASS_NAME_POSITION_RELATIVE = 'position-relative';
const BS_CLASS_NAME_WIDTH_FULL = 'w-100';

const CLASS_NAME_OPACITY_0 = 'opacity-0';

function setupLoadingSpinner($, submit, form) {
    const loader = new AjaxLoader(null, {
        light: true,
        size: 'xs'
    });

    const $submit = $(submit);
    const $form = $(form);

    const $container = $('<div></div>').addClass(BS_CLASS_NAME_POSITION_RELATIVE).attr('role', 'text');
    const $loader = $('<div></div>').addClass([BS_CLASS_NAME_POSITION_ABSOLUTE, BS_CLASS_NAME_WIDTH_FULL]).html(loader.render());
    const $content = $('<div></div>').html($submit.html());

    $container.append([ $loader, $content ]);
    $submit.html($container);

    $form.submit(() => {
        if($form.valid()) {
            $submit.prop('disabled', true);
            $content.addClass(CLASS_NAME_OPACITY_0);
            loader.active = true;
        }
    });
}

$(() => {
    const els = document.querySelectorAll('.js-sc-form-submit');
    els.forEach((el) => {
        const $submit = $(el);
        const $form = $submit.closest('form[data-ajax="true"]');

        if(window.$ && window.$.fn.validate && $form.length) {
            setupLoadingSpinner(window.$, $submit.get(0), $form.get(0));
        }
    });
});
